import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import EmbeddedApp from 'components/embedded-app';

// Same default as the dashboard section; `.env.local` can point at the touring Vite dev server.
const TOUR_BUDGET_URL = process.env.REACT_APP_TOUR_BUDGET_URL || '/tour-budget-app/index.html';

/** Public `/tour-budget`: the calculator without the dashboard shell, for anonymous visitors and shared `#t=` links. */
const TourBudget: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box display="flex" sx={{ height: 'calc(100vh - 72px)' }}>
      <EmbeddedApp
        title={t('Tour budget')}
        url={TOUR_BUDGET_URL}
        allow="clipboard-write; fullscreen"
      />
    </Box>
  );
};

export default TourBudget;
